import { faArrowLeft, faBars, faFloppyDisk, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import { getDomain, getIdInUrl, tempAlWait } from "../../helpers";
import { addGallerie, delGallerie, getDetailGallerie } from "../../actions/gallerie";
import { connect } from "react-redux";
import AdminHeader from "../../components/AdminHeader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AdminHaut from "../../components/AdminHaut";
import Alert from "../../components/Alert";

class AdminGallerieEdit extends React.Component {
    state = {
        menuActive: false,
        opts: [
            {
                type: 'link',
                ttl: "Retourner à la galerie",
                ico: faArrowLeft,
                link: "/admin/galerie",
                action: null,
                col: null
            }, {
                type: 'button',
                ttl: "Supprimer l'image",
                ico: faTrashCan,
                link: null,
                action: () => {
                    if (window.confirm("Souhaitez-vous réellement supprimer cette image ?")) {
                        this.setState({
                            alert: tempAlWait()
                        })
                        this.props.delGallerie({gallId: this.state.id})
                    }
                },
                col: "red"
            }
        ],
        form: {
            img: null,
            imgRes: null,
            desc: ''
        },
        alert: {
            active: false,
            type: '',
            title: '',
            desc: ''
        },
        id: null
    }

    componentDidMount() {
        document.querySelectorAll('.dispAdmin').forEach(el => {
            el.style.display = "none";
        })
        document.getElementById('page').classList.add('pageWithout');

        if (this.props.canContinue) {
            this.setState({id: getIdInUrl()});
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.canContinue != this.props.canContinue) {
            if (this.props.canContinue) {
                this.setState({id: getIdInUrl()});
            }
        }

        if (prevState.id != this.state.id && this.state.id != null) {
            this.props.getDetailGallerie({gallId: this.state.id});
            this.setState({
                alert: tempAlWait()
            })
        }
        if (prevProps.redSaveGall != this.props.redSaveGall) {
            this.setState({
                alert: this.props.redSaveGall.alert
            })
        }
        if (prevProps.redDelGall != this.props.redDelGall) {
            this.setState({
                alert: this.props.redDelGall.alert
            })
        }
        if (prevProps.redDetGall != this.props.redDetGall) {
            if (this.props.redDetGall.alert.type == "succ") {
                this.setState({
                    alert: this.props.redDetGall.alert,
                    form: {
                        img: null,
                        imgRes: this.props.redDetGall.datas.img,
                        desc: this.props.redDetGall.datas.desc
                    }
                })
            } else {
                this.setState({
                    alert: this.props.redDetGall.alert
                })
            }
        }
    }

    handleSave(el) {
        el.preventDefault();
        this.setState({
            alert: tempAlWait()
        })
        this.props.addGallerie({
            img: this.state.form.img,
            desc: this.state.form.desc,
            gallId: this.state.id
        });
    }

    getBase64 = file => {
        return new Promise(resolve => {
            let baseURL = "";

            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                baseURL = reader.result;
                resolve(baseURL);
            }
        })
    }
    
    render() {
        return <main className={`admin ${this.state.menuActive && "admin--active"}`}>
            <AdminHeader
                handleClose={(el) => this.setState({menuActive: el})}
                active={this.state.menuActive}
                changeAlert={(el) => this.setState({alert: el})}
                idtt={this.props.idtt}
            />
            {/** Bouton menu **/}
            <button
                title="Ouvrir le menu"
                aria-label="Ouvrir le menu"
                onClick={() => this.setState({menuActive: true})}
                className="adminHdr__btnOpen"
            >
                <FontAwesomeIcon icon={faBars} />
            </button>

            {/** Header de page **/}
            <AdminHaut 
                ttl="Modifier l'image"
                options={this.state.opts}
            />
            
            {/** Données de la page **/}
            <div className="admin__ctnr">
                {/** Formulaire **/}
                <form className="admin__form">
                    {/** Description **/}
                    <div className="admin__inpgrp" title="Description courte de l'image" aria-label="Description courte de l'image">
                        <label htmlFor="gallerie-desc" className="admin__lab">
                            Description de l'image
                        </label>
                        <textarea
                            placeholder="Description courte de l'image"
                            className="admin__input admin__input--txtarea" 
                            id="gallerie-desc"
                            onChange={(el) => {
                                this.setState(prevState => ({
                                    form: {
                                        ...prevState.form,
                                        desc: el.target.value
                                    }
                                }))
                            }}
                            value={this.state.form.desc}></textarea>
                    </div>

                    {/** Image **/}
                    <div className="admin__inpgrp admin__inpgrp--img" title="Image" aria-label="Image">
                        <label htmlFor="gallerie-image" className="admin__lab">
                            Image
                        </label>
                        <input
                            type="file"
                            accept="image/*"
                            className="admin__input"
                            id="gallerie-image"
                            onChange={(el) => {
                                this.getBase64(el.target.files[0])
                                    .then(result => {
                                        el.target.files[0]["base64"] = result;

                                        this.setState(
                                            prevState => ({
                                                form: {
                                                    ...prevState.form,
                                                    img: result
                                                }
                                            })
                                        )
                                    })
                                    .catch(err => {console.log(err)})
                            }}
                        />
                        {
                            this.state.form.img == null ?
                                (this.state.form.imgRes != null ?
                                    <img src={`${getDomain()}image/gallerie/${this.state.form.imgRes}`} alt="Image en cours de chargement" className="admin__inpimg" />  :
                                    <div></div>) :
                                    <img src={this.state.form.img} alt="Image en cours de chargement" className="admin__inpimg" /> 
                        }
                    </div>

                    {/** Bouton sauvegarde **/}
                    <button
                        title="Modifier l'image"
                        aria-label="Modifier l'image"
                        className="admin__btnsave"
                        type="button"
                        onClick={(el) => this.handleSave(el)}
                    >
                        <FontAwesomeIcon icon={faFloppyDisk} />
                        <span className="admin__btnsavetxt">Modifier</span>
                    </button>
                </form>
            </div>
            <Alert alert={this.state.alert}/>
        </main> 
    }
}

const mapStateToProps = state => {
    return {
        redDelGall: state.redDelGall,
        redDetGall: state.redDetGall,
        redSaveGall: state.redSaveGall
    }
}

const mapDispatchToProps = {
    delGallerie,
    getDetailGallerie,
    addGallerie
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminGallerieEdit);